import { Pipe, PipeTransform } from '@angular/core';
import { TimerFormats } from '../models/timer-formats.model';

@Pipe({
	name: 'filterTimerFormats'
})
export class FilterTimerFormatsPipe implements PipeTransform {
	transform(timerFormats: Array<TimerFormats>, format: string, selectedElementIndex: number): Array<TimerFormats> {
		const f = format && format.toLowerCase();

		switch (f) {
			case '%a': {
				return timerFormats.filter(
					(timerFormat) => timerFormat.value.toLowerCase() === f || timerFormat.value.toLowerCase() === '%h'
				);
			}

			case '%h': {
				return timerFormats.filter(
					(timerFormat) => timerFormat.value.toLowerCase() === f || timerFormat.value.toLowerCase() === '%a'
				);
			}

			case '%d':
			case '%i':
			case '%s': {
				return timerFormats.filter((timerFormat) => timerFormat.value.toLowerCase() === f);
			}

			case '': {
				return timerFormats.filter((timerFormat) => timerFormat.groupId === selectedElementIndex);
			}

			default: {
				return timerFormats;
			}
		}
	}
}
